<form [formGroup]="form" novalidate="novalidate">
    <div class="modal-header">
        <h4 class="modal-title" *ngIf="type == 'quote'">{{ 'RejectedQuote' | translate }}</h4>
        <h4 class="modal-title" *ngIf="type == 'story'">{{ 'RejectedStory' | translate }}</h4>
        <h4 class="modal-title" *ngIf="type == 'task'">{{ 'RejectedTask' | translate }}</h4>
        <h4 class="modal-title" *ngIf="type == 'contract'">{{ 'RejectedContract' | translate }}</h4>
        <div>
            <i class="fe fe-x black-menu" ngbTooltip="{{ 'Close' | translate }}" (click)="activeModal.dismiss()"></i>
        </div>
    </div>
    <div class="modal-body">
        <div class="form-floating">
            <textarea class="form-control m-0" formControlName="Reason" placeholder=""
                [ngClass]="{'is-invalid': submitted && f['Reason'].invalid, 'is-valid': submitted && f['Reason'].valid }"
                style="height: 150px"></textarea>
            <label class="form-label">
                {{ 'Reason' | translate }} <sup class="text-danger fs-6">*</sup>
            </label>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" (click)="activeModal.dismiss()">
            <i class="fe fe-x"></i>
            <span>{{ 'Cancel' | translate }}</span>
        </button>
        <button *ngIf="!rejectReason" type="submit" class="btn btn-sm btn-custom"
            [disabled]="(httpService.getLoading('rejectLoader'))" (click)="submit()">
            <ng-container *ngIf="(httpService.getLoading('rejectLoader'))">
                <span class="spinner-border spinner-border-sm" role="status"></span>
                <span>{{ 'Saving' | translate }} ...</span>
            </ng-container>
            <ng-container *ngIf="!(httpService.getLoading('rejectLoader'))">
                <i class="fe fe-check"></i>
                <span>{{ 'Save' | translate }}</span>
            </ng-container>
        </button>
    </div>
</form>